import React from 'react';
import { cn } from '@/core/lib/utils';

interface LegendItem {
  type: string;
  label: string;
  color: string;
}

interface TimelineLegendProps {
  items?: LegendItem[];
  className?: string;
}

const defaultLegendItems: LegendItem[] = [
  { type: 'seizure', label: 'Seizure', color: 'bg-red-500' },
  { type: 'medication', label: 'Medication', color: 'bg-blue-500' },
  { type: 'symptom', label: 'Symptom', color: 'bg-orange-500' },
  { type: 'sleep', label: 'Sleep', color: 'bg-purple-500' },
  { type: 'feeding', label: 'Feeding', color: 'bg-green-500' },
  { type: 'therapy', label: 'Therapy', color: 'bg-teal-500' },
  { type: 'appointment', label: 'Appointment', color: 'bg-indigo-500' },
  { type: 'note', label: 'Note', color: 'bg-gray-500' },
];

export function TimelineLegend({ 
  items = defaultLegendItems,
  className 
}: TimelineLegendProps): React.ReactElement {
  return (
    <div className={cn('flex flex-wrap gap-4', className)}>
      {items.map((item) => (
        <div key={item.type} className="flex items-center gap-2">
          <span className={cn('w-3 h-3 rounded-full', item.color)} />
          <span className="text-sm text-gray-600">{item.label}</span>
        </div>
      ))}
    </div>
  );
}

export default TimelineLegend;